import { render } from "./VmsView.vue?vue&type=template&id=0c7c8d93&scoped=true"
import script from "./VmsView.vue?vue&type=script&lang=js"
export * from "./VmsView.vue?vue&type=script&lang=js"

import "./VmsView.vue?vue&type=style&index=0&id=0c7c8d93&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c7c8d93"]])

export default __exports__